<!-- eslint-disable max-len -->
<template>
  <b-container fluid>
    <b-row class="mt-2">
      <b-col>
        <b-breadcrumb :items="breadcrumb" />
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col md="2">
        <h2 class="h2">
          Projects
        </h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <b-form-group
          label-cols="3"
          label="Filter"
          class="mb-0"
        >
          <b-input-group>
            <b-form-input
              v-model="filter"
              placeholder="Type to Search"
              debounce="800"
            />
            <b-input-group-append>
              <b-btn
                :disabled="!filter"
                @click="filter = ''"
              >
                Clear
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col
        md="6"
        class="my-1"
      >
        <b-form-group
          label-cols="3"
          label="Per page"
          class="mb-0"
        >
          <b-form-select
            v-model="perPage"
            :options="pageOptions"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      show-empty
      responsive="md"
      small
      hover
      outlined
      :items="projectStatuses"
      :fields="getFields"
      :filter="filter"
      :current-page="currentPage"
      :per-page="perPage"
      @filtered="onFiltered"
    >
      <template #cell(sandbox)="row">
        <div v-if="row.item.sandbox">
          <font-awesome-icon icon="check-circle" />
        </div>
      </template>
      <template #cell(provisioned)="row">
        <div v-if="row.item.provisioned">
          <font-awesome-icon icon="check-circle" />
        </div>
      </template>
      <template #cell(options)="row">
        <b-button
          v-if="row.item.unstickable"
          title="Reset Provisioning"
          size="sm"
          variant="warning"
          class="mr-2 mb-1"
          @click.stop="unstickProject(row.item)"
        >
          <font-awesome-icon icon="tractor" />
        </b-button>
        <b-button
          size="sm"
          :title="row.detailsShowing && rowDetailBtnStatus.showEdit ? 'Cancel' : 'Edit'"
          :disabled="(openRow && !row.detailsShowing) || isEditDisabled(row.item.status)"
          class="mr-2 mb-1"
          @click.stop="editRow(row)"
        >
          <font-awesome-icon icon="edit" />
        </b-button>
        <template v-if="canAccessOptions(row.item)">
          <b-button
            ref="deletePromptShow"
            v-b-modal.deletePrompt
            title="Delete"
            size="sm"
            :disabled="openRow || !canDelete(row.item)"
            variant="danger"
            class="mr-2 mb-1"
            @click.stop="deleteProjectEnv(row)"
          >
            <font-awesome-icon icon="trash-alt" />
          </b-button>
          <!-- <template v-if="showApproval(row.item.projectName)">
            <b-button
              v-b-modal.approvalPrompt
              title="Delete"
              size="sm"
              :disabled="openRow || !canDelete(row.item)"
              variant="danger"
              class="mr-2 mb-1"
            >
              <font-awesome-icon icon="trash-alt" />
            </b-button>
          </template> -->
          <b-button
            v-if="!row.item.needDltApproval && isCIE && row.item.status == 'Requested' && row.item.needSecurityApproval"
            title="Approve"
            size="sm"
            :disabled="openRow || row.item.status !== 'Requested'"
            variant="success"
            class="mr-2 mb-1"
            @click.stop="approveProject(row.item)"
          >
            <font-awesome-icon icon="check" />
          </b-button>
          <b-button
            v-if="isCIEDLT && row.item.status == 'Requested' && row.item.needDltApproval"
            title="Approval Pending for DLT Team"
            size="sm"
            :disabled="openRow || row.item.status !== 'Requested'"
            variant="success"
            class="mr-2 mb-1"
            @click.stop="approveProject(row.item)"
          >
            <font-awesome-icon icon="check" />
          </b-button>
          <b-button
            v-if="!row.item.needDltApproval && isCIE && canReject(row.item) && row.item.needSecurityApproval"
            v-b-modal.rejectPrompt
            title="Reject"
            size="sm"
            :disabled="openRow || !canReject(row.item)"
            variant="danger"
            class="mr-2 mb-1"
            @click.stop="editProject = row.item"
          >
            <font-awesome-icon icon="ban" />
          </b-button>
          <b-button
            v-if="isCIE && row.item.status == 'Approved'"
            title="Provision"
            size="sm"
            :disabled="(openRow && !row.detailsShowing) || provisionPending"
            variant="primary"
            class="mr-2 mb-1"
            @click.stop="provisionProject(row.item)"
          >
            <font-awesome-icon icon="cogs" />
          </b-button>
          <b-button
            v-if="row.item.provisioned || row.item.sandbox"
            :title="(row.detailsShowing && rowDetailBtnStatus.showDetail ? 'Hide' : 'Show') + ' Details'"
            size="sm"
            :disabled="openRow && !row.detailsShowing"
            class="mr-2 mb-1"
            @click.stop="detailRow(row)"
          >
            <font-awesome-icon icon="info-circle" />
          </b-button>
          <!-- credman button -->
          <b-button
            v-if="row.item.provisioned"
            :title="(row.detailsShowing && rowDetailBtnStatus.showCredManPanel ? 'Hide' : 'Show') + ' CredMan Panel'"
            size="sm"
            variant="secondary"
            class="mr-2 mb-1"
            :disabled="canAccessCredMan(row.item)"
            @click.stop="credManPanel(row)"
          >
            <font-awesome-icon icon="lock" />
          </b-button>
          <b-button
            v-if="row.item.provisioned"
            :title="(row.detailsShowing && rowDetailBtnStatus.showRGandK8sPanel ? 'Hide' : 'Show') + ' Resource Group and K8s Panel'"
            size="sm"
            variant="secondary"
            class="mr-2 mb-1"
            @click.stop="RgAndK8sPanel(row)"
          >
            <font-awesome-icon icon="boxes" />
          </b-button>
          <b-button
            v-if="row.item.provisioned"
            :title="(row.detailsShowing && rowDetailBtnStatus.showCalendar ? 'Hide' : 'Show') + ' Scheduled Deletion'"
            size="sm"
            variant="secondary"
            class="mr-2 mb-1"
            @click.stop="editSchedule(row)"
          >
            <font-awesome-icon icon="calendar-minus" />
          </b-button>
          <b-button
            v-if="row.item.provisioned"
            :title="(row.detailsShowing && rowDetailBtnStatus.showGitHubPanel ? 'Hide' : 'Show') + ' GitHub Panel'"
            size="sm"
            variant="secondary"
            class="mr-2 mb-1"
            @click.stop="githubPanel(row)"
          >
            <font-awesome-icon :icon="['fab', 'github']" />
          </b-button>
          <b-button
            v-if="
              canProvisionSandbox &&
                row.item.status !== 'Requested' &&
                !row.item.status.startsWith('Provisioning') &&
                !row.item.status.startsWith('AutoProvisioning') &&
                !row.item.sandbox
            "
            title="Provision in SANDBOX"
            :disabled="provisionPending || !canSandbox(row.item)"
            size="sm"
            variant="primary"
            @click.stop="provisionSandbox(row.item)"
          >
            <font-awesome-icon icon="flask" />
          </b-button>
        </template>
      </template>

      <template #row-details="row">
        <div v-if="rowDetailBtnStatus.showGitHubPanel">
          <GitHubPanel :project="row.item" />
        </div>
        <div v-if="rowDetailBtnStatus.showCredManPanel">
          <CredManPanel
            :project="row.item"
            :projenv="editProject.options"
          />
        </div>
        <div v-if="rowDetailBtnStatus.showRGandK8sPanel">
          <RgAndK8sPanel
            :project="row.item"
            :projenv="editProject.options"
          />
        </div>

        <div v-if="rowDetailBtnStatus.showDetail">
          <h4>Project Resource Indicators</h4>
          <b-table
            bordered
            outlined
            hover
            :items="row.item.indicators"
            :fields="indicatorsFields"
          />
          <GitHubStatus :project="row.item" />
          <h4>Provision Logs</h4>
          <LogTable :project="row.item" />
        </div>

        <div v-if="rowDetailBtnStatus.showCalendar">
          <h4>
            Schedule Deletion on Provisioned Environments
          </h4>
          <div>
            <h6><b>Note: </b>1. You can only schedule deletion of pre-prod environment resources.</h6>
            <!-- eslint-disable-next-line -->
            <h6>&emsp;&emsp;&ensp;&nbsp;2. The CRON job runs every hour starting at 00:00 HRS UTC. It deletes all the scheduled deletions in the previous hour, according to how you have set it up.</h6>
            <!-- eslint-disable-next-line -->
            <h6>&emsp;&emsp;&ensp;&nbsp;Example - If the current time is 2:14 PM UTC and if you set it up to run every hour, then it will delete resources at 4:00 PM UTC, 5:00 PM UTC and so on.</h6>
            <!-- eslint-disable-next-line -->
            <h6>&emsp;&emsp;&ensp;&nbsp;3. Only 5 or 6 character CRON expression is allowed. (Year restricted).</h6>
            <!-- eslint-disable-next-line -->
            <h6 v-if="checksandbox">&emsp;&emsp;&ensp;&nbsp;4. To avoid the deletion of specific resources including in Sandbox, you can "lock" the resources in Azure.</h6>
            <!-- eslint-disable-next-line -->
            <h6><a href="https://docs.oracle.com/cd/E12058_01/doc/doc.1014/e12030/cron_expressions.htm" target="_blank">Click here</a> to know how to schedule cron job</h6>
          </div>
          <br>
          <form @submit.prevent="scheduleDeletion(row)">
            <div
              v-for="environmentDetail in cronExpressionDetails"
              :key="environmentDetail.id"
            >
              <h6>
                {{ environmentDetail.label }}
                <input
                  id="checkbox"
                  v-model="environmentDetail.checked"
                  type="checkbox"
                >
                <label for="checkbox">{{ environmentDetail.checked ? 'Enabled' : 'Disabled' }}</label>
              </h6>
              <b-form-input
                v-model="environmentDetail.cronExpression"
                type="text"
                :state="validateCronExpression(environmentDetail.cronExpression)"
                :disabled="!environmentDetail.checked"
              />
              <h6 v-if="validateCronExpression(environmentDetail.cronExpression, 'expression')">
                <!-- eslint-disable-next-line -->
                Fire {{ require('cronstrue').toString(((environmentDetail.cronExpression).trim().startsWith('*'))?(environmentDetail.cronExpression).trim().replace(/^\S+/g, '0'):(environmentDetail.cronExpression).trim()) }}
              </h6>
            </div>
            <div v-if="checksandbox">
              <h6>
                SANDBOX
              </h6>
              <b-form-input
                type="text"
                placeholder="This is set for the final Saturday of each month"
                :state="true"
                :disabled="true"
              />
            </div>
            <br>
            <div>
              <b-btn
                v-if="updateButtonStatus(cronExpressionDetails)"
                type="submit"
                variant="primary"
                :disabled="updateButton"
              >
                Update Schedules
              </b-btn>
            </div>
          </form>
        </div>

        <div v-if="rowDetailBtnStatus.showEdit">
          <h4>Edit Your Project</h4>
          <form @submit.prevent="submitProjectUpdate(row)">
            <b-form-group
              label="Project Name"
              :description="descriptions.projectName"
              :invalid-feedback="invalidFeedbacks.projectName"
              :state="validateProjectName"
            >
              <b-form-input
                v-model="editProject.projectName"
                type="text"
                :disabled="editProject.provisioned"
                :state="validateProjectName"
              />
            </b-form-group>
            <b-form-group
              label="Department"
              :description="descriptions.departmentId"
              :invalid-feedback="invalidFeedbacks.departmentId"
              :state="validateDepartment"
            >
              <b-form-input
                v-model="editProject.departmentId"
                type="text"
                :state="validateDepartment"
              />
            </b-form-group>

            <b-form-group
              label="Product"
              :description="descriptions.financeProduct"
              :invalid-feedback="invalidFeedbacks.financeProduct"
              :state="validateFinanceProduct"
            >
              <b-input-group>
                <b-form-select
                  v-model="financeProductName"
                  :options="financeProductNames"
                />
                <b-input-group-append>
                  <b-input-group-text
                    v-b-hover="handleFinanceProductInfoHover"
                    :class="financeProductInfoHover ? 'text-muted pointer-cursor' : ''"
                    @click="showFinanceProductInfoModal"
                  >
                    <font-awesome-icon
                      id="finance-product-info-icon"
                      icon="info-circle"
                    />
                  </b-input-group-text>
                  <b-modal
                    ref="financeProductInfoModal"
                    title="What's 'Product' For?"
                    hide-footer
                    centered
                  >
                    Used by finance to assign costs to business groups.
                  </b-modal>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <b-form-group
              label="Product Description"
              :description="descriptions.productDescription"
              :invalid-feedback="invalidFeedbacks.productDescription"
              :state="validateProductDescription"
            >
              <b-form-input
                v-model="editProject.productDescription"
                type="text"
                :state="validateProductDescription"
              />
            </b-form-group>

            <b-form-group
              label="Security Level"
              :description="descriptions.securityLevel"
              :invalid-feedback="invalidFeedbacks.securityLevel"
            >
              <b-input-group>
                <b-form-select
                  v-model="editProject.securityLevel"
                  :options="securityLevelList"
                />
                <b-input-group-append>
                  <b-input-group-text
                    v-b-hover="handleSecurityLevelInfoHover"
                    @click="showSecurityLevelInfoModal"
                  >
                    <font-awesome-icon
                      id="security-level-info-icon"
                      icon="info-circle"
                      :class="securityLevelInfoHover ? 'text-muted pointer-cursor' : ''"
                    />
                  </b-input-group-text>
                  <b-modal
                    ref="securityLevelInfoModal"
                    hide-footer
                    title="How to choose?"
                    centered
                  >
                    <ul>
                      <li>
                        <strong>security-critical:</strong> Private access only to the team. Code contains trade secrets.
                        Exposure of this code to competitors would cause significant financial harm to MSI. <br>
                        Patented algorithms or functionality.
                      </li>
                      <li>
                        <strong>security-medium (default):</strong> Code cannot be open sourced. Code is customer facing functionality
                        that contains features provided to our customers.
                      </li>
                      <li>
                        <strong>security-low:</strong> If the other two levels do not apply, select this level.
                      </li>
                    </ul>
                  </b-modal>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <b-form-group
              :description="descriptions.usApprover"
              :state="validateUsApproverCoreId"
              :invalid-feedback="invalidFeedbacks.usApprover"
            >
              <UsersTagInput
                v-model="editProject.usApprover"
                label="US Approver"
                :minimum-users="0"
                :maximum-users="15"
                :invalid-feedback="invalidFeedbacks.usApprover"
              />
            </b-form-group>
            <b-form-group
              :description="descriptions.cccsApprover"
              :state="validateCccsApproverCoreId"
              :invalid-feedback="invalidFeedbacks.cccsApprover"
            >
              <UsersTagInput
                v-model="editProject.cccsApprover"
                label="CCCS Approver"
                :minimum-users="0"
                :maximum-users="15"
                :invalid-feedback="invalidFeedbacks.cccsApprover"
                :disabled="isCCCSdisabled"
              />
            </b-form-group>

            <b-form-group
              :description="descriptions.nonSovereignApprover"
              :state="validateNonSovereignApproverCoreId"
              :invalid-feedback="invalidFeedbacks.nonSovereignApprover"
            >
              <UsersTagInput
                v-model="editProject.nonSovereignApprover"
                label="Non Sovereign Approver"
                :minimum-users="0"
                :maximum-users="15"
                :invalid-feedback="invalidFeedbacks.nonSovereignApprover"
              />
            </b-form-group>

            <b-form-group
              :description="descriptions.securityChampion"
              :state="validateSecurityChampionCoreId"
              :invalid-feedback="invalidFeedbacks.securityChampion"
            >
              <UsersTagInput
                v-model="editProject.securityChampion"
                label="Security/Compliance Champion"
                :minimum-users="0"
                :maximum-users="4"
              />
            </b-form-group>

            <b-form-group
              :description="descriptions.pdm"
              :state="validatePdmCoreId"
              :invalid-feedback="invalidFeedbacks.pdm"
            >
              <UsersTagInput
                v-model="editProject.pdm"
                label="PDM"
                :minimum-users="1"
                :maximum-users="4"
              />
            </b-form-group>

            <b-form-group
              :description="descriptions.devManager"
              :state="validateDevManagerCoreId"
              :invalid-feedback="invalidFeedbacks.devManager"
            >
              <UsersTagInput
                v-model="editProject.devManager"
                label="Dev Manager"
                :minimum-users="1"
                :maximum-users="4"
              />
            </b-form-group>

            <UsersTagInput
              v-model="editProject.owners"
              :minimum-users="2"
              label="Project Owners"
            />
            <UsersTagInput
              v-model="editProject.users"
              :minimum-users="1"
              label="Project Contributors"
            />
            <UsersTagInput
              v-model="editProject.logReaders"
              :minimum-users="1"
              label="Log Readers"
            />
            <UsersTagInput
              v-model="editProject.metricReaders"
              :minimum-users="1"
              label="Metric Readers"
            />

            <b-form-group label="Azure Environments">
              <treeselect
                v-model="editProject.environments"
                :multiple="true"
                :options="editProject.options"
                :value-consists-of="valueConsistsOf"
                :auto-load-root-options="true"
              />
            </b-form-group>

            <b-form-group
              v-if="showAws"
              label="AWS Environments"
            >
              <treeselect
                v-model="editProject.awsEnvironments"
                :multiple="true"
                :options="editProject.awsOptions"
                :value-consists-of="valueConsistsOf"
                :auto-load-root-options="false"
              />
            </b-form-group>

            <div
              class="border-top my-3"
            >
              <b-button
                v-b-toggle.users-only-fields
                variant="link"
              >
                Advanced Options
              </b-button>
            </div>
            <b-collapse id="users-only-fields">
              <b-form-group
                label="Max number of load balancers"
                :description="descriptions.resourceQuotas"
                :invalid-feedback="invalidFeedbacks.loadbalancers"
                :state="validateLoadbalancers"
              >
                <b-form-input
                  v-model="editProject.resourceQuotas.loadbalancers"
                  type="number"
                  :state="validateLoadbalancers"
                />
              </b-form-group>
            </b-collapse>
            <div>
              <b-btn
                :disabled="disableButton"
                type="submit"
                variant="primary"
                @click="updateProject"
              >
                Update Project
              </b-btn>
              <b-btn
                :disabled="disableButton"
                variant="info"
                @click="updateUsers(row)"
              >
                Update Members
              </b-btn>
            </div>
          </form>
        </div>
      </template>
    </b-table>
    <b-row>
      <b-col
        md="6"
        class="my-1"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        />
      </b-col>
    </b-row>
    <!-- delete modal section -->
    <b-modal
      id="deletePrompt"
      header-bg-variant="danger"
      header-text-variant="light"
      centered
      title="Delete Project"
      @ok="deleteProject"
    >
      <template v-if="!showApproval">
        <b-container fluid>
          {{ `Are you sure you want to delete` }}
          <strong>{{ editProject.projectName }}</strong> ?
          <template v-if="showDeleteOptions">
            <h6>Please select the environments that you would like to delete from project {{ editProject.projectName }}:</h6>
            <b-form-checkbox-group
              id="checkbox-group-for-environments"
              v-model="toBeDeletedEnv"
              :options="environmentDetails"
              value-field="id"
              text-field="label"
              stacked
              :disabled="disableCheckBox"
            />
            <br>
            <p>*Please note that this only deletes the resources in specified environments and does not affect ADO and resource groups.</p>
            <br>
            <h6>To delete the entire project including ADO space, resource groups and kubernetes namespace, please select this option -</h6>
            <b-form-checkbox
              id="selectAllToDelete"
              @change="selectAllForDelete"
            >
              Delete Complete Project
            </b-form-checkbox>
          </template>
          <h6>Type the name of the project to confirm</h6>
          <b-input v-model="confirmProjectName" />
        </b-container>
        <div slot="modal-footer">
          <b-button
            class
            @click="hideModal"
          >
            Cancel
          </b-button>
          <b-button
            class
            variant="primary"
            :disabled="(toBeDeletedEnv.length == 0 && environmentDetails.length != 0) || (confirmProjectName !== editProject.projectName)"
            @click="deleteProject"
          >
            Ok
          </b-button>
        </div>
      </template>
      <template v-else>
        <p>
          A request has been made to delete the project or project environment with the following details, please approve or reject the request to proceed:
        </p>
        <b-card
          v-for="approvalItem in approvalData"
          :key="approvalItem.ticketNumber"
        >
          <b-card-text>
            Jira Ticket No. :  {{ approvalItem.ticketNumber }}
          </b-card-text>
          <b-card-text>
            Request raised by :  {{ approvalItem.requestedUser }}
          </b-card-text>

          <b-card-text> Request Content: The request is raised for deleting <strong>{{ approvalItem.projectName }}</strong></b-card-text>

          <b-link
            :href="'https://publicengines.atlassian.net/servicedesk/customer/portal/6/'+approvalItem.ticketNumber"
            target="_blank"
            class="card-link"
          >
            Jira link to Request Ticket
          </b-link>
        </b-card>
        <div slot="modal-footer">
          <b-button
            class
            @click="hideModal"
          >
            Cancel
          </b-button>
          <b-button
            class
            variant="primary"
            @click="hideModal"
          >
            Ok
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="rejectPrompt"
      header-bg-variant="info"
      header-text-variant="light"
      centered
      title="Reject Project"
      @ok="rejectProject"
    >
      <p>
        {{ 'Reason project was rejected:' }}
        <b-textarea v-model="reason" />
      </p>
    </b-modal>
    <!-- approval framework modal -->
    <b-modal
      id="approvalPrompt"
      header-bg-variant="info"
      header-text-variant="light"
      centered
      title="Project Aprroval Request"
    >
      <p>
        A request is being raised to delete the project or project environment with below
        details kindly approve or reject the request to proceed
        further
      </p>
      <b-card
        v-for="approvalItem in approvalItems"
        :key="approvalItem.request_no"
      >
        <b-card-text>
          Jira Ticket No. :  {{ approvalItem.request_no }}
        </b-card-text>
        <b-card-text>
          Request raised by :  {{ approvalItem.requested_by }}
        </b-card-text>

        <b-card-text> Request Content: Delete for blah blah ... (put the request detail in here)</b-card-text>

        <b-link
          :href="'https://publicengines.atlassian.net/servicedesk/customer/portal/6/'+approvalItem.request_no"
          target="_blank"
          class="card-link"
        >
          Jira link to Request Ticket
        </b-link>
      </b-card>
    </b-modal>
    <!-- end of approval framework -->
  </b-container>
</template>

<script>
import Vue from 'vue';
import api from '@/api';
import VueToastr2 from 'vue-toastr-2';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import _ from 'lodash';
import toastr from 'toastr';
import {authService} from '../authService';

import LogTable from '@/components/LogTable.vue';
import GitHubPanel from '@/components/GitHubPanel.vue';
import CredManPanel from '@/components/CredManPanel.vue';
import GitHubStatus from '@/components/GitHubStatus.vue';
import UsersTagInput from '@/components/UsersTagInput.vue';
import RgAndK8sPanel from '@/components/RgAndK8sPanel';
import {StakeHoldersMaxLimit} from '../constants/StakeHoldersMaxLimit';

window.toastr = toastr;

Vue.use(VueToastr2);

const indicatorsFields = [
  {
    key: 'resourceType',
    label: 'Type',
    sortable: true,
  },
  {
    key: 'resourceValue',
    label: 'Value',
    sortable: true,
  },
];

// eslint-disable-next-line require-jsdoc
function shallowEquals(object1, object2) {
  for (const key in object1) {
    if (key.charAt() !== '_' && object1[key] !== object2[key]) {
      return false;
    }
  }
  return true;
}

export default {
  components: {
    LogTable,
    GitHubPanel,
    GitHubStatus,
    Treeselect,
    UsersTagInput,
    CredManPanel,
    RgAndK8sPanel,
  },
  data() {
    return {
      activeUser: {},
      breadcrumb: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Projects',
          active: true,
        },
      ],
      canProvisionSandbox: false,
      confirmProjectName: '',
      currentPage: 1,
      currentRow: {},
      descriptions: {
        departmentId: 'Department ID that owner affiliates with. You can find it in MSI Directory Services.',
        devManager: 'Please enter your dev manager\'s CoreID.',
        financeProduct: 'Select a product from the dropdown.',
        pdm: 'Please enter your product development manager\'s CoreID.',
        productDescription: 'Briefly describe your product.',
        projectName: 'Used as the prefix for Azure Resource Group and VSTS project names. Please separate words with a dash (-).',
        resourceQuotas: 'This value will be applied to the team\'s Kubernetes namespace resourceQuota.',
        securityChampion: 'Please enter your Security/Compliance champion\'s CoreID.',
        securityLevel: 'Select a security level.',
        usApprover: 'Please enter your US approver\'s CoreID.',
        cccsApprover: 'Please enter your CCCS approver\'s CoreID.',
        nonSovereignApprover: 'Please enter your Non Sovereign approver\'s CoreID.',
      },
      disableButton: true,
      editProject: {
        departmentId: '',
        devManager: [],
        environments: [],
        financeProduct: '',
        logReaders: [],
        metricReaders: [],
        owners: [],
        pdm: [],
        projectName: '',
        productDescription: '',
        resourceQuotas: {loadbalancers: '0'},
        securityChampion: [],
        securityLevel: 'security-medium',
        usApprover: [],
        cccsApprover: [],
        nonSovereignApprover: [],
        // users is contributors
        users: [],
        updateUserOnly: false,
        // eslint-disable-next-line quotes
        awsEnvironments: [],
      },
      awsOptions: [
        {id: 'dev',
          label: 'DEV US Commercial',
          children: [{
            id: JSON.stringify({
              name: 'dev/us-east-1',
              status: 'Requested',
            }),
            label: 'dev-us-east-1',
          }],
        },
        {
          id: 'prod',
          label: 'PROD US Commercial',
          children: [{
            id: JSON.stringify({
              name: 'prod/us-east-1',
              status: 'Requested',
            }),
            label: 'prod-us-east-1',
          }],
        },
        {
          id: 'gov-prod',
          label: 'PROD US GOV',
          children: [{
            id: JSON.stringify({
              name: 'gov-prod/us-gov-east-1',
              status: 'Requested',
            }),
            label: 'us-gov-east-1',
          }],
        },
      ],
      cccsdisbaledList: [
        'AIS',
        'AMS',
        'appsec',
        'Aware-Web-Video',
        'CCAdmin-V1',
        'CCDrive',
        'cie-btg',
        'CIE-DLT',
        'cie-dlt-federal-provisioning',
        'CIE-Infra',
        'cie-log-processors',
        'cie-prometheus',
        'cie-security',
        'CommunityEngagement',
        'coreGIS',
        'evidence-module',
        'idm20',
        'Location-Service',
        'media-for-evidence',
        'Minerva',
        'ML-Pipeline',
        'OneRMS',
        'Predictive',
        'prosecutor-portal',
        'SaaS-Aware',
        'SaaS-Aware-Backend',
        'Universal-Web-Map',
        'VirtualPartner',
        'VirtualPartner-Vulcan',
      ],
      awsEnvToDisplay: [],
      approvalItems: [],
      approvalData: [],
      environmentDetails: [],
      cronExpressionDetails: [],
      toBeDeletedEnv: [],
      environmentsFromApi: [],
      cronExpression: '',
      scheduleDetails: [],
      checksandbox: false,
      updateButton: false,
      beforeChecking: '',
      filter: null,
      indicators: '',
      indicatorsFields: indicatorsFields,
      invalidFeedbacks: {
        departmentId: 'Required: the department ID.',
        devManager: `Maximum ${StakeHoldersMaxLimit.devManager} CoreIDs are allowed`,
        financeProduct: 'Product is required',
        loadbalancers: 'Max load balancers must be an integer between 0 and 20.',
        pdm: `Maximum ${StakeHoldersMaxLimit.pdm} CoreIDs are allowed`,
        projectName: 'Sorry, space and special characters ("/[]:|<>+=;?*,.) are not allowed.',
        productDescription: 'Sorry, only letters, numbers and space are allowed.',
        securityChampion: `Maximum ${StakeHoldersMaxLimit.securityChampion} CoreIDs are allowed`,
        securityLevel: 'Security level is required.',
        usApprover: `Max only ${StakeHoldersMaxLimit.UsApprover} CoreIDs are allowed`,
        cccsApprover: `Max only ${StakeHoldersMaxLimit.CccsApprover} CoreIDs are allowed`,
        nonSovereignApprover: `Max only ${StakeHoldersMaxLimit.NonSovereignApprover} CoreIDs are allowed`,
      },
      isCIE: false,
      isCIEDLT: false,
      loading: false,
      openRow: false,
      options: null,
      // awsOptions: null,
      pageOptions: [5, 10, 15],
      perPage: 15,
      popUp: '',
      financeProductInfoHover: false,
      financeProducts: [],
      projectStatuses: [],
      provisionPending: false,
      reason: '',
      rowDetailBtnStatus: {
        showDetail: false,
        showEdit: false,
        showGitHubPanel: false,
        showCredManPanel: false,
        showRGandK8sPanel: false,
        showCalendar: false,
      },
      totalRows: 0,
      validPdmCoreId: false,
      validDevManagerCoreId: false,
      validUsApproverCoreId: true,
      validCccsApproverCoreId: true,
      validNonSovereignApproverCoreId: true,
      validSecurityChampionCoreId: true,
      MaxPdmCoreId: StakeHoldersMaxLimit.pdm,
      MaxDevManagerCoreId: StakeHoldersMaxLimit.devManager,
      MaxUsApproverCoreId: StakeHoldersMaxLimit.UsApprover,
      MaxCccsApproverCoreId: StakeHoldersMaxLimit.CccsApprover,
      MaxNonSovereignApproverCoreId: StakeHoldersMaxLimit.NonSovereignApprover,
      MaxSecurityChampionCoreId: StakeHoldersMaxLimit.securityChampion,
      validFeedbacks: 'Thank you',
      disableCheckBox: false,
      valueConsistsOf: 'LEAF_PRIORITY',
      securityLevelInfoHover: false,
      securityLevelList: [
        {value: 'security-critical', text: 'security-critical'},
        {value: 'security-medium', text: 'security-medium'},
        {value: 'security-low', text: 'security-low'},
      ],
    };
  },
  computed: {
    showAws() {
      if (this.isCIE) {
        return true;
      } else {
        return false;
      }
    },
    isCCCSdisabled() {
      if (this.cccsdisbaledList.includes(this.editProject.projectName) && !this.isCIE) {
        return true;
      } else {
        return false;
      }
    },
    showApproval() {
      // console.log('ap count>>', this.approvalItems.length);
      if (this.approvalData.length>0) {
        return true;
      } else {
        return false;
      }
    },
    showDeleteOptions () {
      if (this.environmentDetails && this.environmentDetails.length !=0) {
        return true;
      } else {
        return false;
      }
    },
    getFields () {
      const fields = [
        {
          key: 'projectName',
          sortable: true,
        },
        {
          key: 'departmentId',
        },
        {
          key: 'productDescription',
        },
        {
          key: 'environments',
          formatter: (values, key, item) => {
            if (Array.isArray(values)) {
              const viewArray = values.map((itm) => {
                const currentItm = JSON.parse(itm);
                if (currentItm.env.toLowerCase().startsWith('stag')) {
                  currentItm.env = 'stage';
                }
                const result = _.filter(
                    this.environmentsFromApi,
                    (env) => env.environment.toLowerCase() === currentItm.env && env.azureRegion === currentItm.cloud,
                )[0];
                if (undefined === result) {
                  return '';
                }
                return `${_.toUpper(result.environment)} ${result.regionName}`;
              });
              try {
                const awsArray = item.awsEnvironments && item.awsEnvironments.length!=0?item.awsEnvironments.map((awsItem)=>{
                  if (awsItem && awsItem.name) {
                    const env = awsItem.name.split('/');
                    return `AWS-${env[0].toUpperCase()}`;
                  } else if (typeof awsItem === 'string') {
                    const env = awsItem.split('/');
                    return `AWS-${env[0].toUpperCase()}`;
                  }
                }):[];
                if (awsArray.length!=0) viewArray.push(...awsArray);
              } catch (e) {
                console.log(e);
              }
              return [...new Set(viewArray)].join(', ');
            } else {
              return 'None';
            }
          },
        },
        {
          key: 'createdBy',
        },
        {
          key: 'sandbox',
          class: 'text-center',
        },
        {
          key: 'provisioned',
          class: 'text-center',
        },
        {
          key: 'status',
          sortable: true,
        },
        {
          key: 'options',
        },
      ];
      return fields;
    },
    financeProductName: {
      get() {
        return this.editProject.financeProduct.name;
      },
      set(value) {
        this.editProject.financeProduct = this.financeProducts.find((fp) => fp.name === value);
      },
    },
    financeProductNames() {
      return this.financeProducts.map((fp) => fp.name);
    },
    validateProjectName() {
      const pn = this.editProject.projectName;
      const projectNameRegex = /^[a-zA-Z0-9]{1}((?![~@%#$'"{}/\\[\]:|<>+=;?*,\s]).)*$/g;
      if (pn.length === 0) {
        return null;
      } else if (pn.endsWith('.') || pn.match(projectNameRegex) === null) {
        return false;
      } else {
        return true;
      }
    },
    validateDepartment() {
      if (this.editProject.departmentId.length === 0) {
        return null;
      } else {
        return true;
      }
    },
    validateFinanceProduct() {
      return this.financeProductNames.includes(this.editProject.financeProduct.name);
    },
    validateProductDescription() {
      if (this.editProject.productDescription.length === 0) {
        return null;
      } else if (this.editProject.productDescription.match(/^[a-zA-Z0-9_ ]*$/g) === null) {
        return false;
      } else {
        return true;
      }
    },
    validateLoadbalancers() {
      const {loadbalancers = '0'} = this.editProject.resourceQuotas;

      const loadbalancersNum = Number(loadbalancers);
      if (isNaN(loadbalancersNum)) {
        return false;
      }
      // must be an integer
      if (loadbalancersNum % 1 !== 0) {
        return false;
      }

      return 0 <= loadbalancersNum && loadbalancersNum <= 20;
    },
  },
  asyncComputed: {
    async validateDevManagerCoreId() {
      if (this.editProject.devManager.length === 0) {
        this.validDevManagerCoreId = false; // required
        this.disableButton = true;
      } else if (this.editProject.devManager.length >=1 && this.editProject.devManager.length <= this.MaxDevManagerCoreId) {
        this.validDevManagerCoreId = await this.validateCoreIds(this.editProject.devManager);
        if (this.validDevManagerCoreId) {
          this.disableButton = this.checkIfAllFieldsAreTrue();
        }
      } else {
        this.validDevManagerCoreId = false;
        this.disableButton = true;
      }
      return this.validDevManagerCoreId;
    },
    async validatePdmCoreId() {
      if (this.editProject.pdm.length === 0) {
        this.validPdmCoreId = false; // required
        this.disableButton = true;
      } else if (this.editProject.pdm.length >= 1 && this.editProject.pdm.length <= this.MaxPdmCoreId) {
        this.validPdmCoreId = await this.validateCoreIds(this.editProject.pdm);
        if (this.validPdmCoreId) {
          this.disableButton = this.checkIfAllFieldsAreTrue();
        }
      } else {
        this.validPdmCoreId = false;
        this.disableButton = true;
      }
      return this.validPdmCoreId;
    },
    async validateSecurityChampionCoreId() {
      if (this.editProject.securityChampion.length >=1 && this.editProject.securityChampion.length <= this.MaxSecurityChampionCoreId) {
        this.validSecurityChampionCoreId = await this.validateCoreIds(this.editProject.securityChampion);
        if (this.validSecurityChampionCoreId) {
          this.disableButton = this.checkIfAllFieldsAreTrue();
        }
      } else {
        this.validSecurityChampionCoreId = false;
        this.disableButton = true;
      }
      return this.validSecurityChampionCoreId;
    },
    async validateUsApproverCoreId() {
      if (this.editProject.usApprover.length >=1 && this.editProject.usApprover.length <= this.MaxUsApproverCoreId ) {
        this.validUsApproverCoreId = await this.validateCoreIds(this.editProject.usApprover);
        if (this.validUsApproverCoreId) {
          this.disableButton = this.checkIfAllFieldsAreTrue();
        }
      } else {
        this.validUsApproverCoreId = false;
        this.disableButton = true;
      }
      return this.validUsApproverCoreId;
    },
    async validateCccsApproverCoreId() {
      if (this.editProject.cccsApprover.length >=1 && this.editProject.cccsApprover.length <= this.MaxCccsApproverCoreId ) {
        this.validCccsApproverCoreId = await this.validateCoreIds(this.editProject.cccsApprover);
        if (this.validCccsApproverCoreId) {
          this.disableButton = this.checkIfAllFieldsAreTrue();
        }
      } else {
        this.validCccsApproverCoreId = false;
        this.disableButton = true;
      }
      return this.validCccsApproverCoreId;
    },
    async validateNonSovereignApproverCoreId() {
      if (this.editProject.nonSovereignApprover.length >=1 &&
         this.editProject.nonSovereignApprover.length <= this.MaxNonSovereignApproverCoreId ) {
        this.validNonSovereignApproverCoreId = await this.validateCoreIds(this.editProject.nonSovereignApprover);
        if (this.validNonSovereignApproverCoreId) {
          this.disableButton = this.checkIfAllFieldsAreTrue();
        }
      } else {
        this.validNonSovereignApproverCoreId = false;
        this.disableButton = true;
      }
      return this.validNonSovereignApproverCoreId;
    },
  },
  watch: {
    currentRow: {
      handler() {
        this.disableButton = shallowEquals(this.editProject, this.currentRow);
      },
      deep: true,
    },
    editProject: {
      handler() {
        this.disableButton = shallowEquals(this.editProject, this.currentRow);
      },
      deep: true,
    },
  },
  async beforeCreate() {
    this.activeUser = await authService.getUser();
    this.activeUser.coreId = this.activeUser.preferred_username.split('@')[0];
  },
  beforeDestroy() {
    this.stopPolling();
  },
  async created() {
    try {
      this.canProvisionSandbox = await this.getCanProvisionSandboxFlag();
      this.financeProducts = await api.getFinanceProducts();
      this.approvalItems = await api.getJiraTickets();
    } catch (error) {
      if (!api.isUnauthorisedError(error) && !api.isUnauthenticatedError(error) && typeof error !== 'object') {
        this.$router.push({name: 'error', params: {errorMessage: error}});
      }
    }
  },
  mounted() {
    // Todo: will change the logic in future when api is ready
    this.$nextTick(async () => {
      // Code that will run only after the
      // entire view has been re-renderediron
      try {
        const response = await this.getEnvironmentsFromApi();
        this.environmentsFromApi = response;
        await this.getItems();
        await this.startPolling();
      } catch (error) {
        console.error(error);
      }
    });
    // console.log('ap count>>', this.approvalItems.length);
  },
  methods: {
    // async showApproval(projectName) {
    //   // console.log('ap count>>', this.approvalItems.length);
    //   this.approvalItems= await api.getJiraTickets(projectName);
    //   console.log(this.approvalItems);
    //   if (this.approvalItems.length>0) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    selectAllForDelete(checked) {
      this.disableCheckBox = !this.disableCheckBox;
      this.toBeDeletedEnv = checked ? this.environmentDetails.map((o)=>o.id) : [];
    },
    async approveProject(project) {
      this.setProjectStatus(project, 'Approved');
    },
    applyStatusStyles() {
      this.projectStatuses = this.projectStatuses.map((project) => {
        switch (project.status) {
          case 'Deleting':
            project._rowVariant = 'deleting';
            break;
          case 'Rejected':
            project._rowVariant = 'warning';
            break;
          case 'Provisioning':
            project._rowVariant = 'provisioning';
            break;
          case 'AutoProvisioning':
            project._rowVariant = 'provisioning';
            break;
        }
        return project;
      });
    },
    canAccessOptions(rowItem) {
      const isOwner = rowItem.owners.find((coreId) => coreId === this.activeUser.coreId);
      const isUser = rowItem.users.find((coreId) => coreId === this.activeUser.coreId);
      if (isOwner || isUser || this.isCIE) {
        return true;
      } else {
        return false;
      }
    },
    canAccessCredMan(rowItem) {
      const isOwner = rowItem.owners.find((coreId) => coreId === this.activeUser.coreId);
      const isUser = rowItem.users.find((coreId) => coreId === this.activeUser.coreId);
      if (isOwner || isUser || this.isCIE) {
        return false;
      } else {
        return true;
      }
    },
    canAccessScheduleDeletion(rowItem) {
      const isOwner = rowItem.owners.find((coreId) => coreId === this.activeUser.coreId);
      const isUser = rowItem.users.find((coreId) => coreId === this.activeUser.coreId);
      if (isOwner || isUser || this.isCIE) {
        return false;
      } else {
        return true;
      }
    },
    canDelete(rowItem) {
      const isOwner = rowItem.owners.find((coreId) => coreId === this.activeUser.coreId);
      const isCreatedBy = rowItem.createdBy.split('@')[0] === this.activeUser.coreId;
      if (isOwner || isCreatedBy || this.isCIE) {
        switch (rowItem.status) {
          case 'Requested':
          case 'Rejected':
          case 'Ready':
          case 'ProvisionedWithErrors':
            return true;
          default:
            return false;
        }
      }
      return false;
    },
    canSandbox(rowItem) {
      const isOwner = rowItem.owners.find((coreId) => coreId === this.activeUser.coreId);
      const isCreatedBy = rowItem.createdBy.split('@')[0] === this.activeUser.coreId;
      if (isOwner || isCreatedBy || this.isCIE) {
        return true;
      }
      return false;
    },
    canReject(rowItem) {
      return rowItem.status === 'Requested' || rowItem.status === 'Approved';
    },
    async checkInput() {
      const prepareMessage = (message) => {
        return `<strong>${message}</strong><br />`;
      };
      const baseMessage = 'Missing required info:<br/>';
      this.popUp = baseMessage;
      if (!this.editProject.projectName || this.editProject.projectName.length === 0) {
        this.popUp += prepareMessage('Project name');
      }
      if (!this.editProject.departmentId || this.editProject.departmentId.length === 0) {
        this.popUp += prepareMessage('Department ID');
      }
      if (!this.editProject.financeProduct) {
        this.popUp += prepareMessage('Product');
      }
      if (!this.editProject.productDescription || this.editProject.productDescription.length === 0) {
        this.popUp += prepareMessage('Product description');
      }
      if (!this.editProject.securityLevel || this.editProject.securityLevel.length === 0) {
        this.popUp += prepareMessage('Security Level');
      }
      const checkCoreIds = async (type, coreIds, minimumNumber = 0) => {
        if (!coreIds || !(coreIds.length >= minimumNumber)) {
          return prepareMessage(`${type} CoreIDs (min. ${minimumNumber})`);
        } else {
          const valid = await this.validateCoreIds(coreIds);
          if (!valid) {
            return prepareMessage(`${type} CoreIDs (invalid ids)`);
          }
        }
        return '';
      };
      const checkOptionalCoreId = async (type, coreId) => {
        if (coreId.length !== 0) {
          const valid = await this.validateCoreIds(coreId);
          if (!valid) {
            return prepareMessage(`${type} (invalid id)`);
          }
        }
        return '';
      };
      const checkRequiredCoreId = async (type, coreId) => {
        if (!coreId || coreId.length === 0) {
          return prepareMessage(`${type} (missing id)`);
        } else {
          const valid = await this.validateCoreIds(coreId);
          if (!valid) {
            return prepareMessage(`${type} (invalid id)`);
          }
        }
        return '';
      };
      const promises = [
        checkOptionalCoreId('US Approver', this.editProject.usApprover),
        checkOptionalCoreId('CCCS Approver', this.editProject.cccsApprover),
        checkOptionalCoreId('Non Sovereign Approver', this.editProject.nonSovereignApprover),
        checkOptionalCoreId('Security Champion', this.editProject.securityChampion),
        checkRequiredCoreId('PDM', this.editProject.pdm),
        checkRequiredCoreId('Dev Manager', this.editProject.devManager),
        checkCoreIds('Owners', this.editProject.owners, 1),
        checkCoreIds('Contributors', this.editProject.users, 1),
        checkCoreIds('Log readers', this.editProject.logReaders, 1),
        checkCoreIds('Metric readers', this.editProject.metricReaders, 1),
      ];
      const results = await Promise.all(promises);
      for (const result of results) {
        this.popUp += result;
      }
      return this.popUp === baseMessage;
    },
    defaultModal(rowDetailBtnStatus, current) {
      for (const i in this.rowDetailBtnStatus) {
        if ({}.hasOwnProperty.call(this.rowDetailBtnStatus, i)) {
          rowDetailBtnStatus[i] = false;
        }
      }
      rowDetailBtnStatus[current] = true;
    },
    async detailRow(row) {
      try {
        this.defaultModal(this.rowDetailBtnStatus, 'showDetail');
        this.openRow = !this.openRow;
        this.loading = true;
        if (this.openRow) {
          this.stopPolling();
          const projectsRes = await api.getResourceIndicator(row.item.projectName);
          const awsProjectRes = await api.getAwsProject(row.item.projectName);
          this.filterIndicatorResponse(row.item, projectsRes, awsProjectRes);
          this.loading = false;
        } else {
          this.startPolling();
        }

        row.toggleDetails();
      } catch (err) {
        this.loading = false;
      }
    },
    async editSchedule(row) {
      Object.assign(this.editProject, row.item);
      this.checksandbox = row.item.sandbox;
      this.getEnvironmentOptions();
      this.cronExpression = '';
      // cronExpressionDetails is fetched from EnvironmentsOptions (only provisioned environments)
      const datais = {
        projectName: row.item.projectName,
        cronExpressionDetails: this.cronExpressionDetails,
      };
      // If no data in schedule table will return false else data will be returned
      const environmentStatus = await api.getScheduleDeletion(datais);
      if (environmentStatus != false) {
        // env - Each Environment Detail, this filter modify data using existing data
        this.cronExpressionDetails = this.cronExpressionDetails.filter((env)=>{
          for (const e of environmentStatus) {
            const envs = JSON.parse(env.id);
            const partnerKey = `${envs.env}:${envs.cloud}:${envs.subEnvironment}`;
            if (e.partnerEnvironmentKey == partnerKey) {
              env.cronExpression = e.cronExpression;
              env.checked = e.checked;
              return env;
            }
          }
        });
      }
      delete this.editProject.options;
      this.defaultModal(this.rowDetailBtnStatus, 'showCalendar');
      this.openRow = !this.openRow;
      this.currentRow = row.item;
      if (this.openRow) {
        this.stopPolling();
      } else {
        this.startPolling();
      }
      row.toggleDetails();
    },
    async deleteProject() {
      const sandboxstatus = this.toBeDeletedEnv.includes('sandbox');
      this.editProject.environments = this.toBeDeletedEnv.filter((environment) => environment !== 'sandbox');
      if (this.editProject.provisioned) {
        await api.deleteProvisionedProject(this.editProject, this.disableCheckBox, sandboxstatus);
        const credmanEnvironments = this.editProject.environments.map((env)=>{
          const environment = JSON.parse(env);
          return `${environment.env}:${environment.cloud}:${environment.subEnvironment}`;
        });
        const credmanDeleteParams = {
          projectName: this.editProject.projectName,
          credmanEnvironments: credmanEnvironments,
        };
        await api.deleteCredman(credmanDeleteParams, this.disableCheckBox);
        this.getItems();
        this.hideModal();
      } else {
        await api.deleteProject(this.editProject.projectName);
        this.getItems();
        this.hideModal();
      }
    },
    validateCronExpression(cronExpressionData, checking = '') {
      if ([4, 5].includes(cronExpressionData.trim().replace(/\s\s+/g, ' ').split(' ').length-1)) {
        return true;
      }
      if (checking == '' && cronExpressionData.trim().length == 0) {
        return true;
      }
      return false;
    },
    updateButtonStatus(cronExpressionDetails) {
      for (const env of cronExpressionDetails) {
        if (env.cronExpression.trim().replace(/\s\s+/g, ' ').split(' ').length-1 == 0 && env.cronExpression.trim() != '') {
          this.updateButton = true;
          return true;
        }
        if (![0, 4, 5].includes(env.cronExpression.trim().replace(/\s\s+/g, ' ').split(' ').length-1)) {
          this.updateButton = true;
          return true;
        }
      }
      this.updateButton = false;
      return true;
    },
    editRow(row) {
      this.editProject.pdm = [];
      this.editProject.devManager = [];
      this.editProject.usApprover = [];
      this.editProject.cccsApprover = [];
      this.editProject.nonSovereignApprover = [];
      this.editProject.securityChampion = [];
      // eslint-disable-next-line max-len
      // if (row.item.awsEnvironments && row.item.awsEnvironments.length != 0) {
      //   this.editProject.awsEnvironments = [{id: '{"env":"dev","cloud":"AzureCloud","regionName":"US Commercial"}'}];
      // }
      this.editProject.securityLevel = 'security-medium';
      this.defaultModal(this.rowDetailBtnStatus, 'showEdit');
      this.openRow = !this.openRow;
      this.currentRow = row.item;
      Object.assign(this.editProject, row.item);
      if (this.openRow) {
        this.stopPolling();
      } else {
        this.startPolling();
      }
      this.options = this.getEnvironmentOptions();
      if (row.item.awsEnvironments === undefined) {
        this.editProject.awsEnvironments = [];
      } else {
        this.editProject.awsEnvironments = row.item.awsEnvironments;
      }
      this.getAwsEnvironmentsOptions();
      row.toggleDetails();
    },
    async deleteProjectEnv(row) {
      Object.assign(this.editProject, row.item);
      this.approvalData = this.approvalItems.filter((item) => {
        return row.item.projectName == item.projectName;
      });
      // this.approvalItems= await api.getJiraTickets(row.item.projectName);
      // console.log(this.approvalItems);
      this.checksandbox = row.item.sandbox;
      this.getEnvironmentOptions();
      delete this.editProject.options;
      row.toggleDetails();
    },
    failFeedback() {
      this.$toastr.error(this.popUp, '', {
        positionClass: 'toast-bottom-center',
        timeOut: '200000',
        toastClass: 'toast-style',
      });
    },
    filterIndicatorResponse(map, response, awsProject) {
      map.indicators = [];
      if (awsProject) {
        if (awsProject.ProjectName) {
          const entity = {};
          entity.resourceType = 'Url to log into AWS';
          entity.resourceValue = 'https://myapps.microsoft.com/';
          entity.isActive = true;
          map.indicators.push(entity);
        }
        if (awsProject.DevAccountId) {
          const devAccIdEntity = {};
          devAccIdEntity.resourceType = 'Aws Dev Account Id';
          devAccIdEntity.resourceValue = awsProject.DevAccountId;
          devAccIdEntity.isActive = true;
          map.indicators.push(devAccIdEntity);
        }
        if (awsProject.ProdAccountId) {
          const prodAccIdEntity = {};
          prodAccIdEntity.resourceType = 'Aws Prod Account Id';
          prodAccIdEntity.resourceValue = awsProject.ProdAccountId;
          prodAccIdEntity.isActive = true;
          map.indicators.push(prodAccIdEntity);
        }
      }
      for (const {id, type, data} of response) {
        if (!id) continue;
        const entity = {};
        switch (type) {
          case 'kubeNamespace':
            entity.resourceType = 'Kubernetes Namespace';
            entity.resourceValue = data.metadata.name;
            break;
          case 'azureDevopsServiceEndpoint':
            entity.resourceType = 'Azure Service Endpoint';
            entity.resourceValue = `${data.name}: ${data.id}`;
            break;
          case 'azureServicePrincipal':
            entity.resourceType = 'Service Principal';
            // The below coalese operator(??) with 'data.servicePrincipal.objectId' can be removed in future
            // as objectId comes for projects who has not been provisioned anytime after azure graph implementation has been
            // completely replaced by ms graph
            entity.resourceValue = data.servicePrincipal.displayName + ': ' + (data.servicePrincipal.objectId??data.servicePrincipal.id);
            break;
          case 'azureResourceGroup':
            entity.resourceType = 'Resource Group Name';
            entity.resourceValue = data.name;
            break;
          case 'kubeServiceEndpoint':
            entity.resourceType = 'Kubernetes Service Endpoint';
            entity.resourceValue = data.name + ': ' + data.id;
            break;
          case 'azureKeyVault':
            entity.resourceType = 'Azure Keyvault';
            entity.resourceValue = id;
            break;
          case 'managedAzureKeyvault':
            entity.resourceType = 'DLT Managed Azure Keyvault';
            entity.resourceValue = data.id;
            break;
          case 'azureActiveDirectoryGroup':
            entity.resourceType = 'Azure AD Group';
            entity.resourceValue = data.name + ': ' + data.id;
            break;
          case 'azureActiveDirectoryUSGroup':
            entity.resourceType = 'Azure AD Group';
            entity.resourceValue = data.name + ': ' + data.id;
            break;
          case 'containerRegistryServiceEndpoint':
            entity.resourceType = 'Container Registry Service Endpoint';
            entity.resourceValue = id;
            break;
          case 'awsManagedResourceGroup':
            entity.resourceType = 'AWS Dlt Managed Resource Group';
            entity.resourceValue = data.GroupArn;
            break;
          case 'awsDltManagedSecretManager':
            entity.resourceType = 'AWS Dlt Managed Secret Manager';
            entity.resourceValue = data.ARN;
            break;
          case 'awsIAMRole':
            entity.resourceType = 'AWS Iam Role';
            entity.resourceValue = data.RoleName;
            break;
          case 'awsServiceAccUser':
            entity.resourceType = 'AWS Service Account UserArn';
            entity.resourceValue = data.Arn;
            break;
        }
        if (entity.resourceType) {
          entity.isActive = true;
          map.indicators.push(entity);
        }
      }
    },
    // todo: fix hard coded below
    flattenEnvironments(environments) {
      const flatEnvs = {};
      for (const i in environments) {
        if ({}.hasOwnProperty.call(environments, i)) {
          const e = JSON.parse(environments[i]);
          const key = e.env + '_' + e.cloud;
          flatEnvs[key] = flatEnvs[key] || e;
          if (e.subEnvironment) {
            flatEnvs[key].subEnvironments = flatEnvs[key].subEnvironments || [];
            flatEnvs[key].subEnvironments.push(e.subEnvironment);
            delete flatEnvs[key].subEnvironment;
          }
        }
      }

      const rval = [];
      for (const e in flatEnvs) {
        if ({}.hasOwnProperty.call(flatEnvs, e)) {
          rval.push(flatEnvs[e]);
        }
      }
      return rval;
    },
    async getCanProvisionSandboxFlag() {
      return await api.canProvisionSandbox();
    },
    async getEnvironmentsFromApi() {
      const response = await api.getEnvironments();
      return response;
    },
    getEnvironmentOptions() {
      const isOwner = this.editProject.owners.find((coreId) => coreId === this.activeUser.coreId);
      const isOwnerOrCIE = this.isCIE || isOwner;
      const sorted = _.sortBy(this.environmentsFromApi, [
        function (e) {
          return e.sortOrder;
        },
      ]);
      const $page = this;
      // this will group them by region - ie -US Commercial, US Gov, AU Central...
      const grouped = _.groupBy(sorted, 'regionName');
      this.editProject.options = [];
      this.environmentDetails = [];
      this.cronExpressionDetails = [];
      // note: currentEnvironment is the label
      for (const currentEnvironment in grouped) {
        if ({}.hasOwnProperty.call(grouped, currentEnvironment)) {
          const parent = {
            id: currentEnvironment,
            label: currentEnvironment,
            children: [],
          };
          // currentSubscription is mis-named.  More common name would be environment w/ subenvironments
          for (const currentSubscription of grouped[currentEnvironment]) {
            let isDisabled = true;
            if (
              ($page.isCIE || !currentSubscription.environment.toLowerCase().startsWith('prod')) &&
              (!$page.editProject.provisioned ||
                !$page.editProject.environments.find((env) => {
                  const envObj = JSON.parse(env);
                  return envObj.env === currentSubscription.environment.toLowerCase() && envObj.cloud === currentSubscription.azureRegion;
                }))
            ) {
              isDisabled = false;
            }

            const childId = {
              env: currentSubscription.environment.toLowerCase(),
              cloud: currentSubscription.azureRegion,
              regionName: currentSubscription.regionName,
            };
            const child = {
              id: JSON.stringify(childId),
              label: `${currentSubscription.environment.toUpperCase()} ${currentSubscription.regionName}`,
              isDisabled: isDisabled,
            };

            parent.children.push(child);
            // here is looping through subEnvs in storage table
            let multiIndexSubAlreadyInProject = false;
            const multiIndexSubRegionsAlreadyInProject = [];
            for (let x = 0; x < currentSubscription.subEnvironments.length; x++) {
              const subEnv = currentSubscription.subEnvironments[x];
              let isSubEnvDisabled = false;
              child.children = child.children || [];

              const _e = $page.editProject.environments.find((env) => {
                const _e = JSON.parse(env);
                return (
                  _e.env === currentSubscription['environment'].toLowerCase() &&
                  _e.cloud === currentSubscription['azureRegion'] &&
                  _e.subEnvironment === subEnv.key
                );
              });

              if (subEnv.status === 'closed' || subEnv.status === 'retired') {
                if (!_e) {
                  // env is closed and the subenv is not already in the project, move on
                  continue;
                }
                // otherwise disable because subscription is closed
                isSubEnvDisabled = true;
                // still need to mark "region"
                if (subEnv.key.startsWith('infra2_1')) {
                  multiIndexSubAlreadyInProject = true;
                  const foundRegion = multiIndexSubRegionsAlreadyInProject.find((fr) => fr === subEnv.location.toLowerCase());
                  if (!foundRegion) {
                    multiIndexSubRegionsAlreadyInProject.push(subEnv.location);
                  }
                }
              } else {
                // disable for all non-owners and admins
                if (!isOwnerOrCIE) {
                  isSubEnvDisabled = true;
                }
                // this needs the granularity of if the subEnv has been provisioned.  Not just the project.
                if ($page.editProject.provisioned && _e) {
                  // this says if project has been provisioned and contains this subEnv, don't allow
                  // removing this subEnv.  It really should be if subEnv has been provisioned...
                  // but discovering if this subEnv is has been provisioned is another story
                  isSubEnvDisabled = true;
                  // if the project already has provisioned an infra 2.1 env, owner cannot add another
                  // so mark it and capture region
                  if (subEnv.key.startsWith('infra2_1')) {
                    multiIndexSubAlreadyInProject = true;
                    const foundRegion = multiIndexSubRegionsAlreadyInProject.find((fr) => fr === subEnv.location.toLowerCase());
                    if (!foundRegion) {
                      multiIndexSubRegionsAlreadyInProject.push(subEnv.location);
                    }
                  }
                }
                // don't present sub envs marked admin-only, not already provisioned and user to non-CIE admins
                if (!_e && subEnv.status === 'admin-only' && !$page.isCIE) {
                  continue;
                }
                // if this sub is 2.1 but not in project, and project already has 2.1 skip it for non-CIE admins
                // this should allow admins the ability to override
                if (subEnv.key.startsWith('infra2_1') && !_e && multiIndexSubAlreadyInProject) {
                  const foundRegion = multiIndexSubRegionsAlreadyInProject.find((fr) => fr === subEnv.location.toLowerCase());
                  if (foundRegion) {
                    continue;
                  }
                }
              }
              // next case is if owner and 2.1 environment has already been provisioned
              // if at least one subscription is not disabled, make sure child is not disabled
              if (!isSubEnvDisabled) {
                child.isDisabled = false;
              }
              const _id = {
                env: currentSubscription['environment'].toLowerCase(),
                cloud: currentSubscription['azureRegion'],
                subEnvironment: subEnv.key,
              };

              child.children.push({
                id: JSON.stringify(_id),
                label: `${currentSubscription.environment} ${subEnv.displayName}`,
                isDisabled: isSubEnvDisabled,
              });

              const regionDetails = `${currentSubscription.environment.toUpperCase()} ${childId.regionName}`;
              // console.log(currentSubscription.environment.toLowerCase().startsWith('prod'));
              if (isSubEnvDisabled) {
                this.environmentDetails.push({
                  id: JSON.stringify(_id),
                  label: `${currentSubscription.environment} ${subEnv.displayName} - ` + regionDetails,
                });
              }
              if (isSubEnvDisabled && !currentSubscription.environment.toLowerCase().startsWith('prod')) {
                this.cronExpressionDetails.push({
                  id: JSON.stringify(_id),
                  label: `${currentSubscription.environment} ${subEnv.displayName} - ` + regionDetails,
                  cronExpression: '',
                  checked: false,
                });
              }
            }
          }

          if (currentEnvironment.toLowerCase().startsWith('prod') && !this.isCIE) {
            parent['isDisabled'] = true;
          }
          this.editProject.options.push(parent);
        }
      }
      // Adding sandbox option if present
      if (this.checksandbox) {
        this.environmentDetails.push({
          id: 'sandbox',
          label: 'SANDBOX',
        });
      }
    },
    getAwsEnvironmentsOptions() {
      const awsOptions = [
        {
          id: 'dev',
          label: 'DEV US Commercial',
          children: [{
            id: {
              name: 'dev/us-east-1',
              status: 'Requested',
            },
            label: 'dev-us-east-1',
            isDisabled: false,
          }],
        },
        {
          id: 'prod',
          label: 'PROD US Commercial',
          children: [{
            id: {
              name: 'prod/us-east-1',
              status: 'Requested',
            },
            label: 'prod-us-east-1',
            isDisabled: false,
          }],
        },
        {
          id: 'gov-prod',
          label: 'PROD US GOV',
          children: [{
            id: {
              name: 'gov-prod/us-gov-east-1',
              status: 'Requested',
            },
            label: 'us-gov-east-1',
            isDisabled: false,
          }],
        },
      ];
      if (this.editProject.awsEnvironments &&
         this.editProject.awsEnvironments.length > 0 &&
         typeof this.editProject.awsEnvironments[0] === 'string') {
        this.editProject.awsEnvironments = this.editProject.awsEnvironments.map((env) => {
          return {name: env, status: 'Requested'};
        });
      }
      for (const opt of awsOptions) {
        const env = this.editProject.awsEnvironments.find((env) => env.name === opt.children[0].id.name);
        if (env) {
          opt.children[0].isDisabled = true;
          opt.children[0].id.status = env.status;
        }
        opt.children[0].id = JSON.stringify(opt.children[0].id);
      }
      this.editProject.awsEnvironments = this.editProject.awsEnvironments.map((env) => JSON.stringify(env));
      //   this.getEnvironmentOptions();
      //   const temp= this.deepClone(this.editProject.options);
      //   const awsEnv = temp.filter((env)=>{
      //     if (env.id=='US Commercial') return true;
      //   });
      //   awsEnv.forEach((env)=>{
      //     env.children = env.children.filter((child)=>{
      //       if (child.label == 'DEV US Commercial') return true;
      //     });
      //     env.children.forEach((e)=>{
      //       delete e['children'];
      //     //});
      //   });
      this.editProject.awsOptions= awsOptions;
    },
    deepClone(obj) {
      const visitedNodes = [];
      const clonedCopy = [];
      // eslint-disable-next-line require-jsdoc
      function clone(item) {
        if (typeof item === 'object' && !Array.isArray(item)) {
          if (visitedNodes.indexOf(item) === -1) {
            visitedNodes.push(item);
            const cloneObject = {};
            clonedCopy.push(cloneObject);
            for (const i in item) {
              // eslint-disable-next-line no-prototype-builtins
              if (item.hasOwnProperty(i)) {
                cloneObject[i] = clone(item[i]);
              }
            }
            return cloneObject;
          } else {
            return clonedCopy[visitedNodes.indexOf(item)];
          }
        } else if (typeof item === 'object' && Array.isArray(item)) {
          if (visitedNodes.indexOf(item) === -1) {
            const cloneArray = [];
            visitedNodes.push(item);
            clonedCopy.push(cloneArray);
            for (let j = 0; j < item.length; j++) {
              cloneArray.push(clone(item[j]));
            }
            return cloneArray;
          } else {
            return clonedCopy[visitedNodes.indexOf(item)];
          }
        }

        return item; // not object, not array, therefore primitive
      }
      return clone(obj);
    },
    async getItems() {
      try {
        this.loading = true;
        const projectsRes = await api.getProjects();

        this.isCIE = projectsRes.mode === 'admin';
        this.isCIEDLT = projectsRes.ciemode === 'admin';

        for (const project of projectsRes.projects) {
          // In the back-end, the "product" field is the "productDescription" field.
          project.productDescription = project.product;

          if (undefined !== project.environments && project.environments.length > 0) {
            project.environments = this.inflateEnvironments(project.provisioned, project.environments).map((env) => JSON.stringify(env));
          }

          if (project.awsEnvironments === undefined) {
            project.awsEnvironments = [];
          }

          if (project.resourceQuotas === undefined) {
            project.resourceQuotas = {loadbalancers: '0'};
          } else if (!project.resourceQuotas.loadbalancers) {
            project.resourceQuotas.loadbalancers = '0';
          }
        }
        this.projectStatuses = projectsRes.projects;
        this.totalRows = this.projectStatuses.length;
        this.applyStatusStyles();

        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },
    getV1Environment(e) {
      if (!e.partnerEnvironmentKey) {
        return e;
      }
      const parts = e.partnerEnvironmentKey.split(':');
      e.env = parts[0];
      e.cloud = parts[1];
      // Everything after the second colon is the "subEnv"
      let count = 2;
      let subEnv = '';
      while (count < parts.length) {
        if (count === parts.length - 1) {
          subEnv += parts[count];
        } else {
          subEnv += `${parts[count]}:`;
        }
        count++;
      }
      e.subEnvironments = [subEnv];
      return e;
    },
    async credManPanel(row) {
      Object.assign(this.editProject.environments, row.item.environments);
      await this.getEnvironmentOptions();
      this.defaultModal(this.rowDetailBtnStatus, 'showCredManPanel');
      this.openRow = !this.openRow;
      if (this.openRow) {
        this.stopPolling();
      } else {
        this.startPolling();
      }
      row.toggleDetails();
    },
    async RgAndK8sPanel(row) {
      Object.assign(this.editProject.environments, row.item.environments);
      await this.getEnvironmentOptions();
      this.defaultModal(this.rowDetailBtnStatus, 'showRGandK8sPanel');
      this.openRow = !this.openRow;
      if (this.openRow) {
        this.stopPolling();
      } else {
        this.startPolling();
      }
      row.toggleDetails();
    },
    async githubPanel(row) {
      this.defaultModal(this.rowDetailBtnStatus, 'showGitHubPanel');
      this.openRow = !this.openRow;
      if (this.openRow) {
        this.stopPolling();
      } else {
        this.startPolling();
      }
      row.toggleDetails();
    },
    handleFinanceProductInfoHover(hovered) {
      this.financeProductInfoHover = hovered;
    },
    handleSecurityLevelInfoHover(hovered) {
      this.securityLevelInfoHover = hovered;
    },
    async hideModal() {
      this.confirmProjectName = '';
      this.approvalItems = await api.getJiraTickets();
      this.$root.$emit('bv::hide::modal', 'deletePrompt');
    },
    /**
     * inflate the environments
     *
     * @param {boolean} isProvisioned has the project been provisioned?
     * @param {array} environments from the project
     * @return {array} inflate envs
     */
    inflateEnvironments(isProvisioned, environments) {
      // loop over all the project environments
      const rval = [];
      // loop through project environments
      for (let e of environments) {
        // If the environment is v2, map back to v1
        e = this.getV1Environment(e);
        const subEnvSet = new Set();
        // this is all envs in the environments table
        const definedEnvironments = this.environmentsFromApi;
        const dbEnv = definedEnvironments.find((dbEnv) => {
          return dbEnv.environment.toLowerCase() === e.env.toLowerCase() && dbEnv.azureRegion.toLowerCase() === e.cloud.toLowerCase();
        });
        if (dbEnv === undefined) {
          console.log('Warning - Environment ' + e.env + ' in AzureRegion ' + e.cloud + ' is not configured in environments data table');
          continue;
        }
        // if subEnvironments are present, respect them.
        if (e.subEnvironments) {
          e.subEnvironments.forEach((seKey) => {
            const dbSubEnv = dbEnv.subEnvironments.find((dbSubEnv) => dbSubEnv.key === seKey);
            // found a matching subenv
            if (dbSubEnv) {
              subEnvSet.add(seKey);
            }
          });
          delete e.subEnvironments;
        } else {
          // no specific sub environments saved.  See what is required and add
          dbEnv.subEnvironments.forEach((se) => {
            // bug 54455 - provisioned projects should always have subEnvs in the project data.
            // If the project has been provision AND has no subEnvs, this project was last provisioned before 2.1 envs were available
            // Therefore select the infra2_0 subEnv
            if (isProvisioned) {
              if (se.key === 'infra2_0') {
                subEnvSet.add(se.key);
              }
            } else {
              // update to apply default if configured, and still support required if the env is
              // open, which is effectively not closed
              if ((se.required === true && se.status !== 'closed') || se.status === 'default') {
                subEnvSet.add(se.key);
              }
            }
          });
        }
        subEnvSet.forEach((key) => {
          rval.push({
            env: e.env,
            cloud: e.cloud,
            subEnvironment: key,
          });
        });
      }
      return rval;
    },
    isEditDisabled(status) {
      return status !== 'Requested' && status !== 'Rejected' && status !== 'Ready' && status !== 'ProvisionedWithErrors';
    },
    isNotProdDeployment() {
      // Use this for "feature flagging" things that are not production-ready yet.
      return !window.location.host.includes('cieportal.commandcentral');
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async provisionProject(project) {
      this.provisionPending = true;
      const data = await api.provisionProject(this.sanitizeProject(project));

      this.provisionPending = false;
      project.status = data.newStatus;
      project._rowVariant = 'provisioning';
    },
    async provisionSandbox(project) {
      this.provisionPending = true;
      const resp = await api.provisionSandbox(this.sanitizeProject(project));

      this.provisionPending = false;
      project.status = resp.newStatus;
      project._rowVariant = 'provisioning';
    },
    async rejectProject() {
      this.editProject.message = this.reason;
      this.setProjectStatus(this.editProject, 'Rejected');
    },
    async setProjectStatus(project, status) {
      Object.assign(this.editProject, project);
      this.editProject.status = status;
      if (status === 'Approved') {
        await api.approveProject(this.sanitizeProject(this.editProject));
      } else if (status === 'Rejected') {
        await api.rejectProject(this.sanitizeProject(this.editProject));
      }
      this.getItems();
    },
    sanitizeProject(project) {
      return {
        createdBy: project.createdBy,
        departmentId: project.departmentId,
        devManager: project.devManager,
        environments: this.flattenEnvironments(project.environments),
        financeProduct: {id: project.financeProduct.id},
        logReaders: project.logReaders,
        message: project.message,
        metricReaders: project.metricReaders,
        owners: project.owners,
        pdm: project.pdm,
        // In the back-end, "product" is the product description.
        product: project.productDescription,
        projectName: project.projectName,
        provisioned: project.provisioned,
        resourceQuotas: {loadbalancers: Number(project.resourceQuotas.loadbalancers)},
        sandbox: project.sandbox,
        securityChampion: project.securityChampion,
        securityLevel: !project.securityLevel ? 'security-medium': project.securityLevel,
        status: project.status,
        usApprover: project.usApprover,
        cccsApprover: project.cccsApprover,
        nonSovereignApprover: project.nonSovereignApprover,
        users: project.users,
        updateUserOnly: project.updateUserOnly,
        awsEnvironments: project.awsEnvironments,
      };
    },
    showFinanceProductInfoModal() {
      this.$refs['financeProductInfoModal'].show();
    },
    showSecurityLevelInfoModal() {
      this.$refs['securityLevelInfoModal'].show();
    },
    startPolling() {
      this.interval = setInterval(
          function () {
          // We need to add an endpoint to get just status updates.
          // Fetching the entire list of projects is wasteful
            this.getItems();
          }.bind(this),
          10000,
      );
    },
    stopPolling() {
      clearInterval(this.interval);
    },
    successFeedback() {
      this.$toastr.success('Your Project has been updated!', '', {
        positionClass: 'toast-bottom-center',
        timeOut: '200000',
        toastClass: 'toast-style',
      });
    },
    async updateUsers(row) {
      this.editProject.updateUserOnly=true;
      await this.submitProjectUpdate(row);
    },
    async scheduleDeletion(row) {
      this.updateButton = false;
      const datais = {
        projectName: row.item.projectName,
        cronExpressionDetails: this.cronExpressionDetails,
      };
      datais.cronExpressionDetails = datais.cronExpressionDetails.filter((env)=>{
        // eslint-disable-next-line
        env.cronExpression = (((env.cronExpression).trim().startsWith('*'))?(env.cronExpression).trim().replace(/^\S+/g, '0'):(env.cronExpression).trim());
        return env;
      });
      await api.createOrUpdateScheduleDeletion(datais);
      this.openRow = !this.openRow;
      row.toggleDetails();
      this.startPolling();
    },
    updateProject() {
      this.editProject.updateUserOnly=false;
    },
    async submitProjectUpdate(row) {
      if (!(await this.checkInput())) {
        console.log('this.checkinput failed ');
        this.failFeedback();
        return;
      }
      const prepareCoreIds = (coreIds) => {
        const temp = coreIds.map((id) => id.toUpperCase());
        temp.sort();
        return temp;
      };
      this.editProject.owners = prepareCoreIds(this.editProject.owners);
      this.editProject.users = prepareCoreIds(this.editProject.users);
      this.editProject.logReaders = prepareCoreIds(this.editProject.logReaders);
      this.editProject.metricReaders = prepareCoreIds(this.editProject.metricReaders);
      this.editProject.pdm = prepareCoreIds(this.editProject.pdm);
      this.editProject.usApprover = prepareCoreIds(this.editProject.usApprover);
      this.editProject.cccsApprover = prepareCoreIds(this.editProject.cccsApprover);
      this.editProject.nonSovereignApprover = prepareCoreIds(this.editProject.nonSovereignApprover);
      this.editProject.securityChampion = prepareCoreIds(this.editProject.securityChampion);
      this.editProject.devManager = prepareCoreIds(this.editProject.devManager);
      try {
        const response = await api.updateProject(row.item.projectName, this.sanitizeProject(this.editProject));
        this.successFeedback();
        Object.assign(row.item, this.editProject);
        row.item.status = response.newStatus === 'AutoProvisioning' ? 'AutoProvisioning' : 'Requested';
        if (row.item.status === 'AutoProvisioning') {
          row.item._rowVariant = 'provisioning';
        }

        this.openRow = !this.openRow;
        row.toggleDetails();
        this.startPolling();
      } catch ({
        response: {
          data: {error},
        },
      }) {
        this.popUp = `Error: ${error}`;
        this.failFeedback();
      }
    },
    async unstickProject(project) {
      await api.unstickProject(this.sanitizeProject(project));
      this.getItems();
    },
    async validateCoreIds(coreIds) {
      const results = await api.validateCoreIds(coreIds);
      return results.length === 0;
    },
    checkIfAllFieldsAreTrue () {
      // eslint-disable-next-line max-len
      if (this.validDevManagerCoreId && this.validPdmCoreId && this.validSecurityChampionCoreId) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>
